class Symbol  {

    id = '';
    blacklist = undefined;
    file = '';
    title = '';
    symbolPath = 'https://www.hundeshop.de/out/pictures/productdesigner/symboles/';


    constructor(rawSymbol) {
        this.id = rawSymbol.id;
        this.blacklist = rawSymbol.blacklist;
        this.file = rawSymbol.file;
        this.title = rawSymbol.title;
    }

    isBlacklistedForPerspective(activePerspective) {

        if (this.blacklist === undefined)
            return false;

        for (var bli = 0; bli < this.blacklist.length; bli++) {
            if (this.blacklist[bli].type == 'perspectiv' && this.blacklist[bli].object == activePerspective.id)
            {
                return true;
            }
        }

        return false;
    }

    isBlacklistedForVariants(activeDesignerVariants) {

        if (this.blacklist === undefined)
            return false;

        const selectedVariants = activeDesignerVariants.filter(adv => adv.selectedVar !== null ).map(adv => { return adv.selectedVar; });
        if (selectedVariants.length > 0)
        {
            for (var bli = 0; bli < this.blacklist.length; bli++) {
                if (this.blacklist[bli].type == 'variant')
                {
                    const blacklistForVar = selectedVariants.find(sv => sv.id == this.blacklist[bli].object);
                    if (blacklistForVar !== undefined)
                    {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    getSymbolUrl() {
        return this.symbolPath + this.file;
    }
}

export default Symbol;



// WEBPACK FOOTER //
// ./src/Symbol.js